/**
 * LoopResultCard — loop skill 结果卡片
 *
 * 展示定时任务状态：Job ID、间隔、下次执行、最近输出。
 */

import { memo } from 'react'
import { Timer, Hash, Clock, Terminal } from 'lucide-react'
import './result-cards.less'

interface LoopResult {
  jobId?: string
  interval?: string
  nextExecution?: string
  lastOutput?: string
  status?: string
}

export const LoopResultCard = memo(function LoopResultCard({
  result,
}: {
  result: LoopResult
}) {
  const fields = [
    result.jobId && { icon: Hash, label: 'Job ID', value: result.jobId },
    result.interval && { icon: Timer, label: '执行间隔', value: result.interval },
    result.nextExecution && { icon: Clock, label: '下次执行', value: result.nextExecution },
    result.status && { icon: Terminal, label: '状态', value: result.status },
  ].filter(Boolean) as { icon: typeof Hash; label: string; value: string }[]

  return (
    <div className="result-card">
      {fields.map((field) => (
        <div key={field.label} className="result-card__field">
          <field.icon className="result-card__field-icon" />
          <span className="result-card__field-label">{field.label}</span>
          <span className="result-card__field-value">{field.value}</span>
        </div>
      ))}

      {result.lastOutput && (
        <div className="result-card__output">
          <div className="result-card__output-header">
            <Terminal />
            <span>最近输出</span>
          </div>
          <pre className="result-card__output-pre">{result.lastOutput}</pre>
        </div>
      )}
    </div>
  )
})
